import { useMemberQuery } from "@/queries/organization-queries";
import type { OrganizationMember } from "gitpod-next-api/gitpod/v1/organization_pb";

export function useMember(userId?: string): {
    member?: OrganizationMember;
    isPending: boolean;
    error: Error | null;
} {
    const enabled = !!userId;
    const { data: member, isPending, error } = useMemberQuery(userId ?? "", { enabled });

    return {
        member,
        // In TanStack Query v5, disabled queries report isPending: true because
        // they have no data and never fetched. When we intentionally skip the
        // query (no userId), there is nothing to wait for.
        isPending: enabled && isPending,
        error,
    };
}
